import { Injectable } from '@angular/core';
import { Token } from '@app/auth/models';
import { AuthService } from '@app/auth/services';
import { SetIsAuthenticated } from '@app/auth/store';
import { CookieStorageService } from '@core/services';
import { Store } from '@ngxs/store';
import base64 from 'base-64';
import { Observable, mergeMap, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(
    private authService: AuthService,
    private cookieStorageService: CookieStorageService,
    private _store: Store
  ) {}

  init(): Observable<any> {
    const token = this.cookieStorageService.get('token');
    const refreshToken = this.cookieStorageService.get('refresh-token');

    if (!refreshToken) {
      return this._store.dispatch(new SetIsAuthenticated(false));
    } else if (token) {
      return this._store.dispatch(new SetIsAuthenticated(true, this.getRoles()));
    } else {
      return this.authService.refreshToken(refreshToken).pipe(
        tap((res) => {
          this.store(res);
        }),
        mergeMap(() => this._store.dispatch(new SetIsAuthenticated(true, this.getRoles())))
      );
    }
  }

  store(tokenInfo: Token, rememberMe?: boolean): void {
    const accessTokenTTL = new Date(new Date().setSeconds(new Date().getSeconds() + tokenInfo.expiresIn));
    const refreshTokenTTL = rememberMe
      ? new Date(new Date().setSeconds(new Date().getSeconds() + tokenInfo.refreshTokenTTL))
      : new Date(new Date().setHours(new Date().getHours() + 24)); // 1 day

    this.cookieStorageService.set('token', tokenInfo.accessToken, accessTokenTTL);
    this.cookieStorageService.set('refresh-token', tokenInfo.refreshToken, refreshTokenTTL);
  }

  hasToken(): boolean {
    return this.cookieStorageService.hasKey('refresh-token');
  }

  getRoles(): string[] {
    const token = this.cookieStorageService.get('token');

    if (!token) {
      return [];
    }

    const base64Token: string | undefined = token.split('.')[1];
    const stringified = base64.decode(base64Token || '');

    return JSON.parse(stringified).role;
  }
}
